/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext } from 'react';
import defenderStyles from '../../styles.module.css';
import styles from './styles.module.css';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import ConfigContext from '../../../../../../../../components/ConfigContext';
import { DeviceDetailsContext } from '../../../../index';
import { useTranslation } from 'react-i18next';

export const VirusScanning = () => {
  const { config } = useContext(ConfigContext);
  const deviceDetails = useContext(DeviceDetailsContext);
  const { t } = useTranslation();
  let history = useHistory();
  let style;
  let virusStatus = false;

  if (
    deviceDetails.device.deviceInfo &&
    deviceDetails.device.deviceInfo.deviceDetailsMap &&
    deviceDetails.device.deviceInfo.deviceDetailsMap.DEFENDER_THREAT_LIST
  ) {
    virusStatus = true;
  }

  switch (virusStatus) {
    case true:
      style = styles.danger;
      break;
    case false:
      style = styles.success;
      break;
  }

  const navigateToHistory = () => {
    history.push({
      pathname: `/${config.appName}/virus/history/${deviceDetails.deviceType}/${deviceDetails.deviceIdentifier}`,
      search: '?query=abc',
      state: {
        detail:
          deviceDetails.device.deviceInfo.deviceDetailsMap.DEFENDER_THREAT_LIST,
      },
    });
  };
  return (
    <div className={`${styles.container} ${style}`}>
      <div className={defenderStyles.values}>
        <b>{t('label_virusScanning')}</b>
        <span style={{ float: 'center' }}>
          {virusStatus ? (
            <>
              <div>{t('label_virusDetected')}</div>
              <div>
                <Button className={`${style}`} onClick={navigateToHistory}>
                  {t('label_viewResults')}
                </Button>
              </div>
            </>
          ) : (
            <div>{t('label_virusNotDetected')}</div>
          )}
        </span>
      </div>
    </div>
  );
};

export default VirusScanning;
